import { render } from "./RbiList.vue?vue&type=template&id=34a432d2&scoped=true"
import script from "./RbiList.vue?vue&type=script&lang=js"
export * from "./RbiList.vue?vue&type=script&lang=js"

import "./RbiList.vue?vue&type=style&index=0&id=34a432d2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-34a432d2"

export default script